import { Address } from 'src/store/models/Auth';

export const getAddress = (address: Address): string => {
  const nonEmptyAddress = [
    address?.line1,
    address?.line2,
    address?.zip,
    address?.city,
    address?.country,
  ]
    .filter((v) => v)
    .join(', ');

  return nonEmptyAddress;
};

export const getDistanceFromLatLonInKm = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

export const deg2rad = (deg: number): number => {
  return deg * (Math.PI / 180);
};
